// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResults-cls1_tC5","cls2":"AutoCompleteResults-cls2_9We AutoCompleteResults-cls1_tC5"};